import { Outlet } from "react-router-dom";
import Header from "@/components/store/Header";
import CategoryNav from "@/components/store/CategoryNav";
import Footer from "@/components/store/Footer";
import CartSheet from "@/components/store/CartSheet";
import WhatsAppFab from "@/components/store/WhatsAppFab";

export default function StoreLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#F9FAFB]">
      <Header />
      <CategoryNav />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CartSheet />
      <WhatsAppFab />
    </div>
  );
}
